import { Button } from "@ui/Button";
import { ListTitle } from "@ui/ListTitle";
import { pageVars } from "@ui/layouts/AskConsumerLayout/pageVars";
import { Text } from "@ui/typography/Text";
import { createResource, For, Show } from "solid-js";
import { type DiscoveryCategory, listDiscoveryCategories } from "@/client";
import { CategoryCard } from "./CategoryCard";

type Props = {
	onAll: () => void;
};

const orderCategories = (
	categories: DiscoveryCategory[],
): DiscoveryCategory[] => {
	const picked = pageVars().followedCategoryIds;
	if (picked.length === 0) {
		return categories;
	}
	const preferred = categories.filter((category) =>
		picked.includes(category.id),
	);
	const rest = categories.filter((category) => !picked.includes(category.id));
	return [...preferred, ...rest];
};

export const CategoryGrid = (props: Props) => {
	const [categories] = createResource(async () => {
		const res = await listDiscoveryCategories();
		return res.data?.categories ?? [];
	});

	return (
		<section>
			<div class="askgvt-section-head">
				<ListTitle>Suggested categories</ListTitle>
				<span style={{ flex: 1 }} />

				<Button
					type="button"
					variant="secondary"
					symbol="arrow_forward"
					symbolPosition="after"
					onClick={props.onAll}
				>
					All categories
				</Button>
			</div>
			<Show
				when={!categories.loading}
				fallback={
					<Text size="small" color="fg3">
						Loading categories…
					</Text>
				}
			>
				<div class="askgvt-cats">
					<For each={orderCategories(categories() ?? [])}>
						{(category) => <CategoryCard category={category} />}
					</For>
				</div>
			</Show>
		</section>
	);
};
